<h4 class="panel-title">Link Properties</h4>

<div class="panel-section">
  <label class="field-label">Color</label>
  <div class="link-color-swatches">
    @for (opt of linkColorOptions(); track opt.value) {
      <button
        class="link-color-swatch"
        [class.active]="linkColorCtrl().value === opt.value"
        [style.background]="opt.value"
        [title]="opt.label"
        (click)="linkColorChange.emit(opt.value)"
      ></button>
    }
  </div>
</div>

<div class="panel-section">
  <dojo-single-select
    label="Arrow End"
    [formCtrl]="linkArrowCtrl()"
    [options]="arrowOptions()"
    optionLabel="label"
    optionValue="value"
    size="s"
    (selectionChange)="arrowChange.emit($event)"
  />
</div>

<div class="panel-section">
  <dojo-number-input
    label="Line Width"
    [formCtrl]="linkWidthCtrl()"
    [min]="0.5"
    [max]="8"
    [step]="0.5"
    size="s"
    (input)="widthChange.emit(linkWidthCtrl().value)"
  />
</div>
